import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["widget"]

  connect() {
    this.renderTurnstile()
  }

  renderTurnstile() {
    if (window.turnstile && this.hasWidgetTarget) {
      const sitekey = this.widgetTarget.dataset.sitekey
      const callback = this.widgetTarget.dataset.callback

      // If a widget already exists for this element, reset it first to avoid duplicates
      if (this.widgetId) {
        window.turnstile.reset(this.widgetId)
      }

      this.widgetId = window.turnstile.render(this.widgetTarget, {
        sitekey: sitekey,
        callback: function(token) {
          // Call the form's callback function if needed
          if (callback && window[callback]) {
            window[callback](token)
          }
        },
        "error-callback": function() {
          console.error("Turnstile widget failed to load or verify.")
        },
        "expired-callback": function() {
          console.warn("Turnstile token expired, please re-verify.")
          if (this.widgetId) {
            window.turnstile.reset(this.widgetId)
          }
        }.bind(this)
      })
    }
  }

  disconnect() {
    if (window.turnstile && this.widgetId) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }
}
